// DS: C37
/** Container used to display a deviation using the entire page width */
import React, { useContext } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationType } from '../DeviationViews/_helpers';
import { DeviationTypes } from '../types/deviation';
import DesktopArtStage from './DesktopArtStage';
import DesktopTextualArtStage from './DesktopTextualArtStage';
import CommissionMobileArtStage from './CommissionMobileArtStage';
import MobileArtStage from './MobileArtStage';
import CommissionStage from './CommissionStage';
import SimpleStage from './_partials/SimpleStage';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
}

const ArtStage: React.FC<Props> = ({ deviation, className }) => {
  const isMobile = useContext(MobileContext);
  const deviationType = getDeviationType(deviation);

  if (isMobile) {
    return deviationType === DeviationTypes.COMMISSION ? (
      <CommissionMobileArtStage deviation={deviation} className={className} />
    ) : (
      <MobileArtStage deviation={deviation} className={className} />
    );
  }

  switch (getDeviationType(deviation)) {
    case DeviationTypes.POLL:
    case DeviationTypes.STATUS:
      return <SimpleStage deviation={deviation} />;
    case DeviationTypes.COMMISSION:
      return <CommissionStage deviation={deviation} />;
    case DeviationTypes.TIER:
    case DeviationTypes.JOURNAL:
    case DeviationTypes.LITERATURE:
      return <DesktopTextualArtStage deviation={deviation} className={className} />;
    default:
      return <DesktopArtStage deviation={deviation} className={className} />;
  }
};
ArtStage.displayName = 'ArtStage';

export default ArtStage;
